import { Deck, DeckProps, MapViewState } from "@deck.gl/core";
import * as L from "leaflet";

function getViewState(map: L.Map): MapViewState {
  return {
    longitude: map.getCenter().lng,
    latitude: map.getCenter().lat,
    zoom: map.getZoom() - 1,
    pitch: 0,
    bearing: 0,
  };
}

export function createDeckInstance(
  map: L.Map,
  container: HTMLElement,
  deck?: Deck,
  props?: DeckProps
): Deck {
  if (!deck) {
    const viewState = getViewState(map);
    deck = new Deck({
      ...props,
      parent: container as HTMLDivElement,
      controller: false,
      style: { zIndex: "auto" },
      viewState,
    });
  }
  return deck;
}

export function updateDeckView(deck: Deck, map: L.Map) {
  const viewState = getViewState(map);

  deck.setProps({ viewState });
  deck.redraw();
}
